import { Alert, Box, Button, Heading, List, Modal, Paragraph } from '@zillow/constellation-10';

type AttachmentGuidelinesProps = {
  onClose(): void;
};

export default function AttachmentGuidelines({ onClose }: AttachmentGuidelinesProps) {
  return (
    <Modal
      dividers={false}
      open={true}
      onOpenChange={(isOpen) => !isOpen && onClose()}
      size={{
        base: 'fullScreen',
        md: 'md',
      }}
      header={
        <Heading level={2} textStyle="heading-xs">
          Attachment guidelines
        </Heading>
      }
      body={
        <Box css={{ padding: 'default' }}>
          <Paragraph>For your protection, never share personal information in messages, such as:</Paragraph>
          <List.Root>
            <List.Item css={{ paddingBlock: 0 }}>Social Security numbers</List.Item>
            <List.Item css={{ paddingBlock: 0 }}>Credit card numbers</List.Item>
            <List.Item css={{ paddingBlock: 0 }}>Driver&apos;s license numbers </List.Item>
          </List.Root>
          <Alert role="alert" tone="info" css={{ marginTop: 'default' }}>
            Attachments are deleted 30 days after sending.
          </Alert>
        </Box>
      }
      footer={
        <Button emphasis="filled" onClick={onClose} tone="brand" data-testid="close-button">
          Close
        </Button>
      }
    />
  );
}
